import { Injectable } from '@angular/core';
import gql from 'graphql-tag';
import { CompatibleWith, FwBuild, UpdateConnextMutation } from 'ngx-core-services';
import { ToastFacade } from 'ngx-zcs-components';

export const UPDATE_CONNEXT_RESPONSE_FRAGMENT = gql`
  fragment connextupdateresponse on ConnextUpdateResponse {
    success
  }
`;

@Injectable()
export class ConnextDetailsService {

  constructor(
    private readonly updateConnextMutation: UpdateConnextMutation,
    private readonly toastFacade: ToastFacade,
  ) {}

  async executeFirmwareUpdate(
    deviceId: string,
    category: number,
    labels: { [key: string]: string },
    setIsUpdating: (updating: boolean) => void
  ): Promise<void> {
    setIsUpdating(true);

    try {
      const response = await this.updateConnextMutation.execute(
        UPDATE_CONNEXT_RESPONSE_FRAGMENT,
        {
          deviceId,
          compatibleWith: CompatibleWith(category),
          build: FwBuild.ANY,
          transactionId: new Date().getTime().toString(),
          force: true,
        }
      );

      const success = (response as any)?.data?.updateConnext?.success;

      if (success) {
        await this.toastFacade.present(labels.fwUpdateDescriptionSuccess, 'Success');
      } else {
        throw new Error(labels.fwUpdateDescriptionError);
      }
    } catch (error) {
      await this.toastFacade.present((error as Error).message, 'Error');
    } finally {
      setIsUpdating(false);
    }
  }

}
